import React, { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ThemeToggle } from "../components/ThemeToggle";
export function Privacy() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-white dark:bg-gray-900" data-id="element-350">
      <nav className="fixed top-0 w-full bg-white dark:bg-gray-900 border-b dark:border-gray-700 z-50" data-id="element-351">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-352">
          <div className="flex items-center justify-between h-16" data-id="element-353">
            <button onClick={() => navigate("/")} className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center" data-id="element-354">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-355" />
              Back to Home
            </button>
            <div className="flex items-center space-x-4" data-id="element-356">
              <ThemeToggle data-id="element-357" />
              <div onClick={() => navigate("/")} className="text-xl font-bold text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-700 dark:hover:text-blue-300 transition-colors" data-id="element-358">
                <span data-id="element-359">MVP</span>
                <span data-id="element-360">Hub.co</span>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main className="pt-32 pb-24" data-id="element-361">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-362">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-8 md:p-12" data-id="element-363">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8" data-id="element-364">
              Privacy Policy
            </h1>
            <p className="text-gray-700 dark:text-gray-200 mb-8" data-id="element-365">
              Effective Date: February 1, 2025
            </p>
            <div className="space-y-8" data-id="element-366">
              <section data-id="element-367">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-368">
                  1. Company Information
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-369">
                  LeanOps LLC ("Company," "we," "our," or "us") operates the
                  website MVPHub.co ("Website"). We are committed to protecting
                  your privacy. This Privacy Policy explains how we collect,
                  use, and share your information. If you have any questions,
                  you can contact us at:
                </p>
                <div className="mt-4 text-gray-700" data-id="element-370">
                  <p data-id="element-371">
                    Business Address: 16192 Coastal Hwy, Lewes, Delaware 19958
                  </p>
                  <p data-id="element-372">
                    Email:{" "}
                    <a href="mailto:privacy@mvphub.co" className="text-blue-600 hover:text-blue-700 underline" data-id="element-373">
                      privacy@mvphub.co
                    </a>
                  </p>
                </div>
              </section>
              <section data-id="element-374">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-375">
                  2. Types of Data Collected
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-376">
                  We collect the following types of information:
                </p>
                <div className="mt-2 text-gray-700 space-y-2" data-id="element-377">
                  <p data-id="element-378">
                    Personal Information: Name, email address, payment details.
                  </p>
                  <p data-id="element-379">
                    Non-Personal Information: Device data, IP address, usage
                    analytics.
                  </p>
                </div>
              </section>
              <section data-id="element-380">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-381">
                  3. How Data is Collected
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-382">
                  We collect data in the following ways:
                </p>
                <div className="mt-2 text-gray-700 space-y-2" data-id="element-383">
                  <p data-id="element-384">
                    Manually Provided Data: When you fill out signup forms or
                    interact with LLM prompts.
                  </p>
                  <p data-id="element-385">
                    Automatically Collected Data: Cookies, tracking pixels,
                    analytics tools.
                  </p>
                  <p data-id="element-386">
                    Third-Party Data: Information from LinkedIn, CRM
                    integrations.
                  </p>
                </div>
              </section>
              <section data-id="element-387">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-388">
                  4. Purpose of Data Collection
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-389">
                  We collect user data to:
                </p>
                <div className="mt-2 text-gray-700 space-y-2" data-id="element-390">
                  <p data-id="element-391">Facilitate account creation and service delivery.</p>
                  <p data-id="element-392">Provide marketing communications and analytics.</p>
                  <p data-id="element-393">
                    Improve AI-powered MVP evaluation and scoping processes.
                  </p>
                </div>
              </section>
              <section data-id="element-394">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-395">
                  5. Data Sharing & Third Parties
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-396">
                  We may share data with third parties as follows:
                </p>
                <div className="mt-2 text-gray-700 space-y-2" data-id="element-397">
                  <p data-id="element-398">
                    Development Partners: To enhance platform functionality.
                  </p>
                  <p data-id="element-399">Payment Processors: For secure transaction processing.</p>
                  <p data-id="element-400">
                    Analytics Tools: To monitor and improve user experience.
                  </p>
                </div>
                <p className="mt-4 text-gray-700" data-id="element-401">
                  We use third-party services including Google Analytics,
                  Stripe, AWS, and OpenAI. We do not sell or rent user data.
                </p>
              </section>
              <section data-id="element-402">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-403">
                  6. Data Storage & Security
                </h2>
                <div className="text-gray-700 space-y-2" data-id="element-404">
                  <p data-id="element-405">User data is stored on AWS servers.</p>
                  <p data-id="element-406">
                    Security measures include encryption and access controls to
                    prevent unauthorized access.
                  </p>
                </div>
              </section>
              <section data-id="element-407">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-408">
                  7. User Rights & Control
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-409">
                  Users have the right to:
                </p>
                <div className="mt-2 text-gray-700 space-y-2" data-id="element-410">
                  <p data-id="element-411">
                    Access, edit, or delete their personal data upon request.
                  </p>
                  <p data-id="element-412">Opt out of marketing emails and tracking.</p>
                </div>
                <p className="mt-4 text-gray-700" data-id="element-413">
                  To exercise these rights, contact{" "}
                  <a href="mailto:privacy@mvphub.co" className="text-blue-600 hover:text-blue-700 underline" data-id="element-414">
                    privacy@mvphub.co
                  </a>
                  .
                </p>
              </section>
              <section data-id="element-415">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-416">
                  8. Cookies & Tracking Technologies
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-417">We use:</p>
                <div className="mt-2 text-gray-700 space-y-2" data-id="element-418">
                  <p data-id="element-419">
                    Cookies and Tracking Pixels: Google Analytics, Facebook
                    Pixel.
                  </p>
                  <p data-id="element-420">
                    Third-Party Tracking: Enabled to enhance service delivery.
                  </p>
                </div>
                <p className="mt-4 text-gray-700" data-id="element-421">
                  Users can manage cookie preferences through browser settings.
                </p>
              </section>
              <section data-id="element-422">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-423">
                  9. Children's Privacy
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-424">
                  We do not knowingly collect data from users under 13 years
                  old.
                </p>
              </section>
              <section data-id="element-425">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-426">
                  10. Legal Compliance
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-427">
                  We are in the process of aligning with GDPR (for EU users) and
                  CCPA (for California users). Users will be notified once
                  compliance is fully implemented.
                </p>
              </section>
              <section data-id="element-428">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-429">
                  11. Policy Updates & Changes
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-430">
                  We may update this Privacy Policy from time to time. Users
                  will be notified via email and website notices.
                </p>
              </section>
              <section data-id="element-431">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-432">
                  12. Contact Information
                </h2>
                <p className="text-gray-700 dark:text-gray-200" data-id="element-433">
                  For questions about this Privacy Policy, contact us at{" "}
                  <a href="mailto:privacy@mvphub.co" className="text-blue-600 hover:text-blue-700 underline" data-id="element-434">
                    privacy@mvphub.co
                  </a>
                  .
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>;
}